import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'pcln-design-system'

const getRoundtripText = (activeTabId, tripType, isSBS, searchSlices, roundTripDepartureHeader) => {
  let text = 'Choose your flight'
  if (tripType === 'RT') {
    text = activeTabId === 1 ? roundTripDepartureHeader : 'Choose your return flight'
  } else if (tripType === 'MD' && isSBS) {
    text = `Choose your flight from ${searchSlices?.[activeTabId - 1]?.originAirport} to ${
      searchSlices?.[activeTabId - 1]?.destinationAirport
    }`
  }

  return text
}

const ListingsHeader = ({ activeTabId, tripType, searchSlices, isSBS = false }) => {
  const cityNameFrmStr = searchSlices?.[0]?.destinationCityName
    ? searchSlices?.[0]?.destinationCityName?.split(',')?.[0]
    : ' '
  const roundTripDepartureHeader = `Choose your flight to ${cityNameFrmStr}`
  return (
    <h1>
      <Text
        fontWeight='bold'
        fontSize={['16px', '16px', '16px', '16px', '20px']}
        pb={['16px', '16px', '16px', '16px', '8px']}
        pl={['16px', '16px', '16px', '16px', '0px']}
      >
        {getRoundtripText(activeTabId, tripType, isSBS, searchSlices, roundTripDepartureHeader)}
      </Text>
    </h1>
  )
}

ListingsHeader.propTypes = {
  activeTabId: PropTypes.number,
  tripType: PropTypes.string,
  isSBS: PropTypes.bool,
  searchSlices: PropTypes.array,
}

export { ListingsHeader }
